<template>
  <div class="mod-overlay" @click.self="$emit('close')">
    <div class="mod-modal">
      <!-- Header -->
      <div class="mod-modal-header">
        <h3 class="mod-modal-title">
          <i :class="isEdit ? 'bi bi-pencil' : 'bi bi-plus-circle'"></i>
          {{ isEdit ? 'Editar objeto' : 'Nuevo objeto' }}
        </h3>
        <button class="mod-modal-close" @click="$emit('close')">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>

      <!-- Body -->
      <form @submit.prevent="handleSubmit" class="mod-modal-body">
        <!-- Error -->
        <div v-if="error" class="mod-alert-error">
          <i class="bi bi-exclamation-triangle-fill"></i>
          {{ error }}
        </div>

        <div class="mod-form-grid">
          <!-- ObjetoId -->
          <div class="mod-field">
            <label for="ObjetoId">ID <span class="mod-required">*</span></label>
            <input
              type="number"
              id="ObjetoId"
              v-model.number="form.ObjetoId"
              :disabled="isEdit"
              required
              placeholder="ID del objeto"
            >
          </div>

          <!-- Nombre -->
          <div class="mod-field">
            <label for="Nombre">Nombre <span class="mod-required">*</span></label>
            <input
              type="text"
              id="Nombre"
              v-model="form.Nombre"
              required
              placeholder="Nombre del objeto"
            >
          </div>

          <!-- TablaEspecifica -->
          <div class="mod-field">
            <label for="TablaEspecifica">Tabla especifica</label>
            <input
              type="text"
              id="TablaEspecifica"
              v-model="form.TablaEspecifica"
              placeholder="Nombre de la tabla"
            >
          </div>
        </div>

        <!-- Footer -->
        <div class="mod-modal-footer">
          <button type="button" class="mod-btn mod-btn-cancel" @click="$emit('close')">
            Cancelar
          </button>
          <button type="submit" class="mod-btn mod-btn-save" :disabled="saving">
            <span v-if="saving" class="mod-spinner-sm"></span>
            <template v-else>
              <i class="bi bi-check-lg"></i>
              {{ isEdit ? 'Guardar cambios' : 'Crear objeto' }}
            </template>
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import objetoService from './objeto.service';
import { showToast } from '@/shared/utils/toast';
import { createObjeto } from './objeto.model';

export default {
  name: 'ObjetoForm',
  props: {
    item: { type: Object, default: null },
    isEdit: { type: Boolean, default: false }
  },
  emits: ['saved', 'close'],
  data() {
    return {
      form: createObjeto(),
      saving: false,
      error: null
    };
  },
  created() {
    if (this.isEdit && this.item) {
      this.form = { ...this.item };
    }
  },
  methods: {
    async handleSubmit() {
      this.saving = true;
      this.error = null;

      if (!this.form.Nombre) {
        this.error = 'Nombre es obligatorio';
        this.saving = false;
        return;
      }

      try {
        const result = await objetoService.guardar(this.form);
        if (result.Number >= 0) {
          showToast(result.Message || 'Guardado correctamente', result.Type || 'success');
          this.$emit('saved');
        } else {
          this.error = result.Message || 'Error al guardar';
        }
      } catch (e) {
        console.error('Error al guardar:', e);
        this.error = 'Error de conexion con el servidor';
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
@import "@/modules/_shared/catalog.css";
</style>
